webpackJsonp([75316017314495],{

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(8);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _Section = __webpack_require__(20);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NarrowContainer = _glamorous2.default.div(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    width: theme.main.maxWidths.text
	  };
	}); /* eslint-disable max-lines */
	
	
	var WideContainer = _glamorous2.default.div(function (_ref2) {
	  var theme = _ref2.theme;
	  return {
	    maxWidth: theme.main.maxWidths.default,
	    width: "100%"
	  };
	});
	
	var VPATTable = _glamorous2.default.table(function (_ref3) {
	  var _ref4;
	
	  var theme = _ref3.theme;
	  return _ref4 = {
	    marginBottom: "5rem"
	  }, _ref4[theme.main.mediaQueries.mobile] = {
	    fontSize: "75%"
	  }, _ref4;
	});
	
	var Accessibility = function Accessibility() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Section2.default,
	      { css: { paddingTop: "calc(100px + 1rem)" } },
	      _react2.default.createElement(
	        NarrowContainer,
	        null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Accessibility"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "To help our clients and partners comply with accessibility standards, we publish information about how Manta is available to people with disabilities. Below you can find the Voluntary Product Accessibility Template, which outlines our compliance with accessibility requirements and design principles described in ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.section508.gov", rel: "noopener noreferrer", target: "_blank" },
	            "Section 508"
	          ),
	          ", a government-wide IT accessibility program in the United States."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Currently, the VPAT only refers to the ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "patron role"
	          ),
	          ", and ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "not"
	          ),
	          " the staff and admin roles."
	        ),
	        _react2.default.createElement("hr", null),
	        _react2.default.createElement(
	          "p",
	          null,
	          "If you have a disability and are having trouble accessing information on this website or need materials in an alternate format, please email ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "support [at] manta.equipment"
	          ),
	          "."
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Section2.default,
	      { css: { paddingTop: 0 } },
	      _react2.default.createElement(
	        WideContainer,
	        null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Voluntary Product Accessibility Template (VPAT)"
	        ),
	        _react2.default.createElement(
	          VPATTable,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                { className: "table-heading", colSpan: "3" },
	                "Summary Table"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "Criteria"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Supporting features"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Remarks"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "Section 1194.21 Software Applications and Operating Systems"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports with exceptions"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "Section 1194.22 Web-based Internet Information and Applications"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports with exceptions"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "Section 1194.23 Telecommunications Products"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "-"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "Section 1194.24 Video and Multimedia Products"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "-"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "Section 1194.25 Self-Contained, Closed Products"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "-"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "Section 1194.26 Desktop and Portable Computers"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "-"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "Section 1194.31 Functional Performance Criteria"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "Section 1194.41 Information, Documentation, and Support"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          VPATTable,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                { className: "table-heading", colSpan: "3" },
	                "Section 1194.21 Software Applications and Operating"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                _glamorous2.default.Th,
	                { width: "45%" },
	                "Criteria"
	              ),
	              _react2.default.createElement(
	                _glamorous2.default.Th,
	                { width: "20%" },
	                "Supporting features"
	              ),
	              _react2.default.createElement(
	                _glamorous2.default.Th,
	                { width: "35%" },
	                "Remarks"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(a) When software is designed to run on a system that has a keyboard, product functions shall be executable from a keyboard where the function itself or the result of performing a function can be discerned textually."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports with exceptions"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "The Manta Equipment user interface is designed to be keyboard friendly, and most tasks can be executed only using a keyboard, with some exceptions:",
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Adding a resource by navigating via the category menu"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Manually navigating the timeline"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(b) Applications shall not disrupt or disable activated features of other products that are identified as accessibility features, where those features are developed and documented according to industry standards. Applications also shall not disrupt or disable activated features of any operating system that are identified as accessibility features where the application programming interface for those accessibility features has been documented by the manufacturer of the operating system and is available to the product developer."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta Equipment does not interfere with or deactivate accessibility features of the user's operating system. Browser keyboard shortcuts, screen readers, magnifiers and other common accessibility tools are not affected."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(c) A well-defined on-screen indication of the current focus shall be provided that moves among interactive interface elements as the input focus changes. The focus shall be programmatically exposed so that assistive technology can track focus and focus changes."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Focus of interface elements is programmatically exposed and signified visually through the use of outlines, changes in color or border. When relevant, outlines are color-coded to indicate usage."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(d) Sufficient information about a user interface element including the identity, operation and state of the element shall be available to assistive technology. When an image represents a program element, the information conveyed by the image must also be available in text."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Partially supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Role and state information is currently not provided for elements in the Manta user interface. Images are currently not used in the Manta interface, hence all relevant information is available textually."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(e) When bitmap images are used to identify controls, status indicators, or other programmatic elements, the meaning assigned to those images shall be consistent throughout an application's performance."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Bitmap images are used consistently throughout Manta Equipment."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(f) Textual information shall be provided through operating system functions for displaying text. The minimum information that shall be made available is text content, text input caret location, and text attributes."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Text is output using conventional elements, utilizing the operating system's functions for displaying text."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(g) Applications shall not override user selected contrast and color selections and other individual display attributes."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports with exceptions"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Contrast settings and color selections at the user level are not overridden by Manta. However, the ease of use of the user interface is reduced when using the highest contrast level on macOS. In particular:",
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Some focusable element borders can no longer be seen"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Focused elements cannot always be discerned"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(h) When animation is displayed, the information shall be displayable in at least one non-animated presentation mode at the option of the user."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta Equipment does not make use of animation to convey information."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(i) Color coding shall not be used as the only means of conveying information, indicating an action, prompting a response, or distinguishing a visual element."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Does not support"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Many elements of the interface duplicate color-coded information as text or via icons, however, several key features heavily rely on color to distinguish properties of an item:",
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "The timeline feature of Manta currently only relies on color coding to distinguish between resources in different states, apart from late checkouts."
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Unavailable items in the resources list are only marked by color tint."
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Active application mode is only indicated by tinting the mode selection buttons."
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(j) When a product permits a user to adjust color and contrast settings, a variety of color selections capable of producing a range of contrast levels shall be provided."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta Equipment does not have an option to modify the theme of the user interface."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(k) Software shall not use flashing or blinking text, objects, or other elements having a flash or blink frequency greater than 2 Hz and lower than 55 Hz."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta Equipment does not use any flashing text or other content."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(l) When electronic forms are used, the form shall allow people using assistive technology to access the information, field elements, and functionality required for completion and submission of the form, including all directions and cues."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports with exceptions"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "The primary process of booking an item can be accomplished with the use of assistive technologies, although some limitations exist:",
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Bookings notes currently cannot be added via keyboard only."
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Booking start and end date must be entered manually, and cannot be picked from a calendar using arrow keys."
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Several elements in the form do not have a role property defined."
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          VPATTable,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                { className: "table-heading", colSpan: "3" },
	                "Section 1194.22 Web-based Internet Information and Applications"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                _glamorous2.default.Th,
	                { width: "45%" },
	                "Criteria"
	              ),
	              _react2.default.createElement(
	                _glamorous2.default.Th,
	                { width: "20%" },
	                "Supporting features"
	              ),
	              _react2.default.createElement(
	                _glamorous2.default.Th,
	                { width: "35%" },
	                "Remarks"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(a) A text equivalent for every non-text element shall be provided (e.g., via \"alt\", \"longdesc\", or in element content)."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports with exceptions"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Most, but not all graphic elements visible to users have text equivalents provided via the \"alt\" tag."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(b) Equivalent alternatives for any multimedia presentation shall be synchronized with the presentation."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta Equipment does not use multimedia presentations."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(c) Web pages shall be designed so that all information conveyed with color is also available without color, for example from context or markup."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports with exceptions"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "All features conveyed with color on Manta are also conveyed via HTML markup and with the use of the &quote;role\" attribute, with a few minor exceptions:",
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Unavailable resources in the resource panel"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Resource status in the timeline"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(d) Documents shall be organized so they are readable without requiring an associated style sheet."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Does not support"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta is a single-page application and relies on style-sheets for functionality and ease of use, therefore it is not readable without the associated style sheets."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(e) Redundant text links shall be provided for each active region of a server-side image map."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta does not use image maps."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(f) Client-side image maps shall be provided instead of server-side image maps except where the regions cannot be defined with an available geometric shape."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta does not use image maps."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(g) Row and column headers shall be identified for data tables."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta Equipment identifies headers for data tables."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(h) Markup shall be used to associate data cells and header cells for data tables that have two or more logical levels of row or column headers."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "The patron role interface for Manta does not have data tables with two or more logical levels of row or column headers."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(i) Frames shall be titled with text that facilitates frame identification and navigation."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta does not use frames."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(j) Pages shall be designed to avoid causing the screen to flicker with a frequency greater than 2 Hz and lower than 55 Hz."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta Equipment does not cause screen flicker."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(k) A text-only page, with equivalent information or functionality, shall be provided to make a web site comply with the provisions of this part, when compliance cannot be accomplished in any other way. The content of the text-only page shall be updated whenever the primary page changes."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta Equipment is a single-page application, therefore it cannot be represented in a text-only format while ensuring functionality. Manta strives to ensure compliance with Section 1194.22 by complying with the other provisions listed."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(l) When pages utilize scripting languages to display content, or to create interface elements, the information provided by the script shall be identified with functional text that can be read by assistive technology."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "All elements created and content provided by scripting are either text-only or accompanied by text element that can be read using assistive technology."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(m) When a web page requires that an applet, plug-in or other application be present on the client system to interpret page content, the page must provide a link to a plug-in or applet that complies with \xA71194.21(a) through (l)."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Not applicable"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta Equipment does not require applets, plug-ins or other third-party applications to be present on the user's system for operation."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(n) When electronic forms are designed to be completed online, the form shall allow people using assistive technology to access the information, field elements, and functionality required for completion and submission of the form, including all directions and cues."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports with exceptions"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "The primary process of booking an item can be accomplished with the use of assistive technologies, although some limitations exist:",
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Bookings notes currently cannot be added via keyboard only."
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Booking start and end date must be entered manually, and cannot be picked from a calendar using arrow keys."
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Several elements in the form do not have a role property defined."
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(o) A method shall be provided that permits users to skip repetitive navigation links."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Does not support"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta does not currently have a way to skip the navigation section of the application."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(p) When a timed response is required, the user shall be alerted and given sufficient time to indicate more time is required."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta Equipment does not require a timed response for any of its core functionality."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          VPATTable,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                { className: "table-heading", colSpan: "3" },
	                "Section 1194.31 Functional Performance Criteria"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                _glamorous2.default.Th,
	                { width: "45%" },
	                "Criteria"
	              ),
	              _react2.default.createElement(
	                _glamorous2.default.Th,
	                { width: "20%" },
	                "Supporting features"
	              ),
	              _react2.default.createElement(
	                _glamorous2.default.Th,
	                { width: "35%" },
	                "Remarks"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(a) At least one mode of operation and information retrieval that does not require user vision shall be provided, or support for assistive technology used by people who are blind or visually impaired shall be provided."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta supports the usage of screen readers for its core functionality."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(b) At least one mode of operation and information retrieval that does not require visual acuity greater than 20/70 shall be provided in audio and enlarged print output working together or independently, or support for assistive technology used by people who are visually impaired shall be provided."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta does not provide tools to scale the font-size on the site, but Manta supports the usage of screen magnifiers."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(c) At least one mode of operation and information retrieval that does not require user hearing shall be provided, or support for assistive technology used by people who are deaf or hard of hearing shall be provided."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta does not use audio throughout the application."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(d) Where audio information is important for the use of a product, at least one mode of operation and information retrieval shall be provided in an enhanced auditory fashion, or support for assistive hearing devices shall be provided."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta does not use audio throughout the application."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(e) At least one mode of operation and information retrieval that does not require user speech shall be provided, or support for assistive technology used by people with disabilities shall be provided."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta does not require user speech."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(f) At least one mode of operation and information retrieval that does not require fine motor control or simultaneous actions and that is operable with limited reach and strength shall be provided."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports with exceptions"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "The Manta Equipment user interface is designed to be keyboard friendly, and most tasks can be executed only using a keyboard, without the need for simultaneous actions, with the exception of manually navigating the timeline (requires hold-and-drag motion)."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          VPATTable,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                { className: "table-heading", colSpan: "3" },
	                "Section 1194.41 Information, Documentation and Support"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                _glamorous2.default.Th,
	                { width: "45%" },
	                "Criteria"
	              ),
	              _react2.default.createElement(
	                _glamorous2.default.Th,
	                { width: "20%" },
	                "Supporting features"
	              ),
	              _react2.default.createElement(
	                _glamorous2.default.Th,
	                { width: "35%" },
	                "Remarks"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(a) Product support documentation provided to end-users shall be made available in alternate formats upon request, at no additional charge."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Manta Equipment is happy to provide documentation for any of the application's features in a user-requested format. This can be requested by contacting the support team via email."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(b) End-users shall have access to a description of the accessibility and compatibility features of products in alternate formats or alternate methods upon request, at no additional charge."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "-"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                "(c) Support services for products shall accommodate the communication needs of end-users with disabilities."
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Supports"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Support for Manta is available via text-based chat or voice call using a platform convenient for the end-user upon request."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Last Edited on 2019-04-18"
	        )
	      )
	    )
	  );
	};
	
	exports.default = Accessibility;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faq-accessibility-js-e06cff48f323579bdb93.js